import { ProjectStageColors, ProjectStages } from 'src/graphql';
import {
  ActiveProjectIcon,
  ProposalIcon,
  ProposalLostIcon,
  ServiceClientIcon,
} from './project-stage-icons';

export const getProjectStageIcon = (projectStageId?: number | null) => {
  const projectStageColor = ProjectStageColors[projectStageId || ProjectStages.ProposalLost];
  const iconSx = {
    width: '1.3125rem',
    height: '1.3125rem',
    display: 'block',
    fontSize: '1.3125rem',
  };

  switch (projectStageId) {
    case ProjectStages.Proposal:
      return <ProposalIcon htmlColor={projectStageColor} sx={iconSx} />;
    case ProjectStages.ActiveProject:
      return <ActiveProjectIcon htmlColor={projectStageColor} sx={iconSx} />;
    case ProjectStages.ServiceClient:
      return <ServiceClientIcon htmlColor={projectStageColor} sx={iconSx} />;
    default:
      return <ProposalLostIcon htmlColor={projectStageColor} sx={iconSx} />;
  }
};
